module.exports = __webpack_public_path__ + "img/5.c7408ecb.jpg";